
  import { defineComponent, onMounted, reactive, ref, onActivated, watch, toRefs } from 'vue'
  import { queryApplyList } from '@/apis/comm/api'

  import { useRouter } from 'vue-router'
  import { useRoute } from 'vue-router'
  import '../../assets/css/ub.css'
  import axios from '@/apis/config'
  import _ from 'lodash'

  export default defineComponent({
    setup() {
      const formRef = ref()
      const route = useRoute()
      const router = useRouter()
      onMounted(() => {
        dataState.currentTime = dataState.formatter(new Date())

        const query = route.query
        if (query && query.token) {
          dataState.token = query.token as any
          dataState.handleQuery(false)
        }
        dataState.resetPc()
      })
      const dataState = reactive({
        currentTime: '',
        token: '',
        dataList: [],
        url: (window as any).VUE_APP_BASE_URL,
        columns: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            customRender: ({ text, record, index }) => index + 1,
            align: 'center'
          },
          {
            title: '被访人',
            dataIndex: 'beAccessName',
            key: 'beAccessName',
            align: 'center'
          },
          {
            title: '人员编号',
            dataIndex: 'beAccessGh',
            key: 'beAccessGh',
            align: 'center'
          },
          {
            title: '到访校区',
            dataIndex: 'visiCampus',
            key: 'visiCampus',
            align: 'center'
          },
          {
            title: '到访日期',
            dataIndex: 'visiStartTime',
            key: 'visiStartTime',
            customRender: ({ text, record, index }) => text.slice(0, 10),
            align: 'center'
          },
          {
            title: '车牌号',
            dataIndex: 'plateNum',
            key: 'plateNum',
            align: 'center'
          },
          {
            title: '车主姓名',
            dataIndex: 'visitorName',
            key: 'visitorName',
            align: 'center'
          },
          {
            title: '联系电话',
            dataIndex: 'visitorPhone',
            key: 'visitorPhone',
            align: 'center'
          },
          // {
          //   title: '申请人姓名',
          //   dataIndex: 'applyerName',
          //   key: 'applyerName',
          //   align: 'center'
          // },
          // {
          //   title: '联系电话',
          //   dataIndex: 'applyerPhone',
          //   key: 'applyerPhone',
          //   align: 'center'
          // },
          {
            title: '车辆入校时间',
            dataIndex: 'intime',
            key: 'intime',
            align: 'center'
          },
          {
            title: '车辆出校时间',
            dataIndex: 'outtime',
            key: 'outtime',
            align: 'center'
          },
          {
            title: '停车时长',
            dataIndex: 'parktimestr',
            key: 'parktimestr',
            align: 'center'
          },
          {
            title: '产生费用',
            dataIndex: 'totalfee',
            key: 'totalfee',
            align: 'center'
          },
          {
            title: '审核状态',
            dataIndex: 'approvalState',
            key: 'approvalState',
            customRender: ({ text, record, index }) => {
              switch (text) {
                case '10':
                  return '同意'
                case '15':
                  return '驳回'
                default:
                  return '未审核'
              }
            },
            align: 'center'
          }
         
        ],
        searchForm: {
          visiStartTime: '',
          plateNum: '',
          visitorName: '',
          visitorPhone: '',
          approvalState:'',
          applyType: 0
        },
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          size: 'small',
          onChange: (page, pageSize) => {
            dataState.getList()
          }
        },
        handleExport() {
          let query = dataState.searchForm
          axios
            .get(dataState.url + '/jdCarsApply/export', {
              params: query,
              headers: {
                Authorization: dataState.token
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                const fileUrl = dataState.url + '/common/download?fileName=' + encodeURI(res.data.msg) + '&delete=' + true // 文件的URL地址
                window.open(fileUrl)
              }
            })
        },
        handleQuery(isReset) {
          if (isReset) {
            formRef.value.resetFields()
          }
          dataState.pagination.current = 1
          dataState.getList()
        },
        async getList() {
          let Page = {
            pageNum: dataState.pagination.current,
            pageSize: dataState.pagination.pageSize
          }
          let query = _.assign({}, Page, dataState.searchForm)
          axios
            .get(dataState.url + '/jdCarsApply/listByPage', {
              params: query,
              headers: {
                Authorization: dataState.token
              }
            })
            .then(res => {
              if (res.data.code == 200) {
                dataState.dataList = res.data.rows
                dataState.pagination.total = res.data.total
              }
            })
        },

        resetPc() {
          var whdef = 100 / 1920 // 表示1920的设计图,使用100PX的默认值
          var bodyWidth = document.body.clientWidth // 当前窗口的宽度
          var rem = bodyWidth * whdef // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
          document.getElementsByTagName('html')[0].style.fontSize = rem + 'px'
        },
        // 日期组件自定义格式
        formatter(time: any) {
          let nowdata = time == null ? new Date() : new Date(time)
          let year = nowdata.getFullYear()
          let month = nowdata.getMonth() + 1
          let date = nowdata.getDate()
          let nowtime = year + '-'
          if (month < 10) {
            nowtime += '0'
          }
          nowtime += month + '-'
          if (date < 10) {
            nowtime += '0'
          }
          nowtime += date

          return nowtime
        }
      })

      return {
        formRef,
        dataState
      }
    }
  })
